import React, { Component } from 'react'
import EditProfile from './EditProfile'
import ErrorMessagePage from '../shared/errorMessagePage/ErrorMessagePage'
import { UserProfileDataViewModel } from '../../models/UserDataViewModel'
import PropTypes from 'prop-types'
import UpdateProfile from '../api/UpdateProfile'
import { HideErrorMessage } from '../shared/constants/EditProfileConstants'
export default class EditProfileUI extends Component {
    state = {
        showErrorMessage:false,
        loading:false,
        email: '',
        confirmEmail: '',
        mobilePhoneNumber: '',
        firstName: '', 
        lastName: '',
        password: '',
        passwordConfirmation:'',
        webId:'',
        isDGContractor:false,
        hiddenValue:'',
        displayMessage:false
    }
    get getEditProfileAPIUrl() {
        return process.env.REACT_APP_EDIT_PROFILE_API
    }
    get getEditProfileUrl() {
        return process.env.REACT_APP_EDIT_PROFILE
    }
    showErrorMessage = () => {
        this.setState( { showErrorMessage: true } )
        window.scrollTo( 0, 0 )
    }
    retrySubmitEvent = () => {
        const { email,confirmEmail,webId,mobilePhoneNumber,password,passwordConfirmation,isDGContractor,hiddenValue,firstName,lastName  } = this.state
        this.setState( { loading : true } )
        UpdateProfile( {
            apiUrl: this.getEditProfileAPIUrl,
            email: email,
            confirmEmail: !confirmEmail ? email : confirmEmail,
            webId: webId,
            mobilePhoneNumber: mobilePhoneNumber,       
              password: password == '' ?  '**************': password,
            confirmPassword: passwordConfirmation == '' ?  '**************': passwordConfirmation,
            isDGContractor: isDGContractor,
            hiddenValue: hiddenValue,
            firstName: firstName,
            lastName: lastName
        } )
        .then( data => { 
            this.setState( { loading : false } )  
            if( data.IsSuccess ){
                this.props.config.userProfileDataViewModel.mobilePhoneNumber = String( mobilePhoneNumber ).replace( /[^0-9]/g, '' )
                this.props.config.userProfileDataViewModel.firstName = firstName
                this.props.config.userProfileDataViewModel.lastName = lastName
                this.props.config.userProfileDataViewModel.email = email
                this.props.config.userProfileDataViewModel.hiddenValue = hiddenValue
                this.setState( { showErrorMessage: false } )
                this.showHideSuccessMessage( true )
            }
            window.scrollTo( 0, 0 )
        } ) .catch( e => {
            this.setState( { loading : false } )  
        } )
    }

    handleSubmit = ( email,confirmEmail,webId,mobilePhoneNumber,password,passwordConfirmation,isDGContractor,hiddenValue,firstName,lastName )=>{
        this.setState ( { email, confirmEmail, webId, mobilePhoneNumber, password, passwordConfirmation, isDGContractor, hiddenValue, firstName, lastName } )
        return UpdateProfile( {
            apiUrl: this.getEditProfileAPIUrl,
            email: email,
            confirmEmail: !confirmEmail ? email : confirmEmail,
            webId: webId,
            mobilePhoneNumber: mobilePhoneNumber,       
              password: password == '' ?  '**************': password,
            confirmPassword: passwordConfirmation == '' ?  '**************': passwordConfirmation,
            isDGContractor: isDGContractor,
            hiddenValue: hiddenValue,
            firstName: firstName,
            lastName: lastName
        } )
    }

    showHideSuccessMessage = ( state ) =>{
        this.setState( { displayMessage: state } )
        if ( state )
            setTimeout( () => this.setState( { displayMessage: !state } ), HideErrorMessage )
    }

    render() {
        const { showErrorMessage, loading,displayMessage } = this.state
        return (
            <>
                { !showErrorMessage ?
                    <EditProfile 
                    showErrorMessage={ this.showErrorMessage }  
                    config={ this.props.config } 
                    handleSubmit = { this.handleSubmit } 
                    displayMessage = { displayMessage }
                    showHideSuccessMessage = { this.showHideSuccessMessage } />
                    : <ErrorMessagePage retrySubmitEvent = { this.retrySubmitEvent } loading = { loading }/>
                }
            </>
        )
    }
}

EditProfileUI.propTypes = {
    config: PropTypes.shape( {       
        userProfileDataViewModel : PropTypes.instanceOf( UserProfileDataViewModel ),
        forgotPasswordUrl: PropTypes.string,
        logInApiUrl: PropTypes.string,
        disablePhoneNumber: PropTypes.bool
    } )
}